import React, { useState, useEffect } from "react";
import VenueCard from "./VenueCard";
import axios from 'axios';



    const BookEventzVenues = ({ sessionData, BASE_URL, INVITES_API }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [bkVenues, setBkVenues] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const cardsPerPage = 4; // For pagination
    const slidePerClick = 4; // Move one image at a time
    const totalPages = Math.ceil(bkVenues.length / cardsPerPage);
    const totalImages = bkVenues.length; // Total venues
    const BASEURL = `${BASE_URL}banquets`;
    const APIURL = `${INVITES_API}api`
    const title = "bookeventz-venues";
    
    useEffect(() => {
        const controller = new AbortController(); // Create an abort controller
    
        const fetchBkVenues = async () => {
        try {
            const response = await axios.get(
            `${APIURL}/city-page/bk-city-venues/${sessionData.CityId}`,
            { signal: controller.signal }
            );
            
            setBkVenues(response.data.venues);
        } catch (error) {
            if (error.name !== "AbortError") {
            console.error("Error fetching BookEventz Venues Data:", error);
            }
        } finally {
            setIsLoading(false);
        }
        };
    
        fetchBkVenues();
    
        return () => controller.abort(); // Cleanup: cancel the request if the component unmounts
    }, []);


    const nextSlide = () => {
        setCurrentPage((prev) => (prev + 4) % bkVenues.length);
    };
    
    const prevSlide = () => {
        setCurrentPage((prev) => (prev - 4 + bkVenues.length) % bkVenues.length);
    };

    const goToPage = (pageIndex) => {
        setCurrentPage(pageIndex * cardsPerPage); // Moves in batches of 4
    };

    const visibleHotels = bkVenues.slice(currentPage, currentPage + cardsPerPage);

    return (
        <>
        { isLoading || bkVenues.length === 0 ? (
            ""
        ) : (
            <>
            <div className="container-city section-city-bk">
            <div className="carousel-city-bk">
                {/* Left Arrow */}
                <div className="left-arrow-city">
                <button
                    type="button"
                    style={{ display: "block" }}
                    onClick={(e) => {
                    e.preventDefault();
                    prevSlide();
                    }}
                    className="nav-button-city-bk nav-button--prev"
                >
                    <img src="../../media/leftArrow.png" alt="left arrow" loading="lazy" />
                </button>
                </div>

                {/* Content */}
                <div>
                    <div className="carousel__grid-title">
                        <h2 className="heading-city-bk">
                        <img
                            src="../../media/bk_icon.svg"
                            alt="bk icon"
                            loading="lazy"
                            style={{
                            width: 24, // ✅ Remove px and use just the number
                            height: 24, // ✅ Remove px and use just the number
                            paddingBottom: 3, // ✅ Use camelCase for CSS properties
                            marginRight: 10,
                            }}
                        />
                        BookEventz Fully Managed Venues in {sessionData.CityName}
                        </h2>
                    </div>

                    <div className="carousel__grid-city">
                        {visibleHotels.map((hotel) => (
                        <VenueCard {...hotel} />
                        ))}
                    </div>

                    <div className="carousel__pagination-city-bk">
                        <div className="pagination-bk">
                        {Array.from({ length: totalPages }).map((_, index) => (
                            <button
                            key={index}
                            onClick={() => goToPage(index)}
                            className={`pagination__dot-bk ${currentPage >= index * cardsPerPage && currentPage < (index + 1) * cardsPerPage ? "pagination__dot--active" : ""}`}
                            aria-label={`Go to page ${index + 1}`}
                            />
                        ))}
                        </div>
                        <div></div>
                    </div>
                    <div className="pagination-bk mb-36">
                        <div>
                            <a href={`${BASEURL}/${title}/${sessionData.CityUniqueLink}`} target="_blank" className="view-all-bk">
                                View all
                                <img src="../../media/stash_arrow-up-dark.svg" alt="right arrow" loading="lazy" className="arrow-icon" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Right Arrow */}
                <div>
                <button
                    type="button"
                    style={{ display: "block" }}
                    onClick={(e) => {
                    e.preventDefault();
                    nextSlide();
                    }}
                    className="nav-button-city-bk nav-button--next"
                    
                >
                    <div className="view-all-img">
                    <img src="../../media/rightArrow.svg" alt="right arrow" loading="lazy" />
                    </div>
                </button>
                </div>
            </div>
            {/* Mobile View */}
            <div className="Carousel-Mobile-view-bk">
                <h2 className="heading-city-bk">
                    <img
                        src="../../media/bk_icon.svg"
                        alt="bk icon"
                        loading="lazy"
                        style={{
                        width: 24, // ✅ Remove px and use just the number
                        height: 24, // ✅ Remove px and use just the number
                        paddingBottom: 3, // ✅ Use camelCase for CSS properties
                        marginRight: 10,
                        }}
                    />
                        BookEventz Fully Managed Venues in {sessionData.CityName}
                </h2>
                <div className="mobile-carousel">
                    <div className="mobile-carousel__container">
                        {bkVenues.map((hotel) => (
                        <div key={hotel.id} className="mobile-carousel__item">
                            <VenueCard {...hotel} />
                        </div>
                        ))}
                    </div>
                </div>
                <div className="view-all-button-container" >
                    <a href={`${BASEURL}/${title}/${sessionData.CityUniqueLink}`} target="_blank" className="view-all-bk">
                        View all
                        <img src="../../media/stash_arrow-up-dark.svg" className="arrow-icon" alt="right arrow" loading="lazy" />
                    </a>
                    
                </div>
            </div>
        </div>
            </>
        )}
    </>
    );
    };

    export default BookEventzVenues;
